export class UserDetailsModel {
  corporateFamilyCode: string;
  customerName: string;
  dealerOrgId: string;
  dealerOrgName: string;
  department: string;
  division: string;
  emailAddress: string;
  employeeNumber: string;
  employeeType: string;
  firstName: string;
  fmCostCenter: string;
  fmFederationID: string;
  fmManagerLevel: string;
  fmbusinessunit: string;
  groups: Array<string>;
  authorizedServicers: Array<string>;
  institutionId: string;
  institutionIdDefault: string;
  institutionNameDefault: string;
  isExternalUser: string;
  isFannieMaeUser: boolean;
  isInternalUser: boolean;
  lastName: string;
  location: string;
  mail: string;
  middleInitial: string;
  mobileNumber: string;
  mornetID: string;
  mornetParntSubscrberId: string;
  mornetPlusId: string;
  parentId: string;
  primaryKeySubcriberId: string;
  sellerServicerCoNo: string;
  streetAddress:string;
  sub: string;
  subscriberMplusId: string;
  subscriberName: string;
  telephoneNumber: string;
  title: string;
  uid: string;
  ultimateParntSubscrberId: string;
  userName: string;
  userType: string;
  workNumber: string;
  constructor() {}
}
